import React from 'react'
import Form from './Form'
import { formTypeList } from '../../constants/form'

const AddNew = ({ setOpen }) => {
    return <Form formType={formTypeList.NEW} setOpen={setOpen} />
}

export default AddNew
